import { axios } from "../../lib/axios";

export const DeleteCartItem = (courseId: string) => {
    return axios.delete(`/cart/removeCourseFromCart/${courseId}`)
        .then(response => response.data);
};